import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { UtilityService } from '../../../core/services/utility.service';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'tt-consignment-split-line',
  templateUrl: './consignment-split-line.component.html',
  styleUrls: ['./consignment-split-line.component.css']
})
export class ConsignmentSplitLineComponent implements OnInit {
    consignmentLineKeyno;

    public edit?: Edit;

    public inputListSplitLines: SplitLineItem[] = [];

    public recalcSumQuantityEnteredSubject = new Subject<void>();

    public saving = false;

    constructor(private stateService: StateService, private utility: UtilityService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentLineKeyno = this.stateService.getStateParams()['consignmentline_keyno'];

        this.recalcSumQuantityEnteredSubject
            .pipe(debounceTime(500))
            .subscribe({ next: () => this.recalcSumQuantityEntered() });
    }

    private async loadEdit() {
        if (!!this.consignmentLineKeyno) {
            this.edit = (await this.datatask.Post(1454, { consignmentline_keyno: this.consignmentLineKeyno }))[0];
        }
    }

    private async loadSplitLines() {
        if (!this.edit) return;

        return this.inputListSplitLines = await this.datatask.Post(1455, { consignmentline_keyno: this.edit.consignmentline_keyno });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;
                
                const inputNumbers = (this.inputListSplitLines ?? []).map((row) => ({
                    consignmentline_keyno: row['consignmentline_keyno'],
                    quantity_topick: row['quantity_topick']
                }));

                const mergeObj = {
                    quantity_total: this.edit.quantity_total,
                    consignmentline_keyno: this.edit.consignmentline_keyno,
                	records: inputNumbers
                }

                const response = (await this.datatask.Post(1456, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private recalcSumQuantityEntered(): void {
        if (!this.edit) return;
        if (!this.inputListSplitLines) return;

        // Reset sum
        let sumQuantityEntered = 0 as number;

        // Loop through input list
        this.inputListSplitLines.forEach(line => {
            const numberQuantityToPick: number = this.utility.parseNumber(line.quantity_topick);
            const numberFixed2Decimals: number = Math.floor(numberQuantityToPick * 100) / 100;

            sumQuantityEntered += numberFixed2Decimals;
            this.edit!.sum_quantity_entered = sumQuantityEntered.toFixed(2) as string;
        });

        // Validation
        if (this.utility.parseNumber(this.edit.quantity_total) !== this.utility.parseNumber(this.edit.sum_quantity_entered)) {
            this.edit.show_validation_text = '1';
        } else {
            this.edit.show_validation_text = '0';
        }

        console.log('quantity_total: ' + this.edit.quantity_total + ' sum_quantity_entered: ' + this.edit.sum_quantity_entered);
        console.log('show_validation_text: ' + this.edit.show_validation_text);
    }

    public onSubtasksChanged() {
        this.recalcSumQuantityEnteredSubject.next();
    }

    private async init() {
        await this.loadEdit();
        
        return Promise.all([
            this.loadSplitLines()
        ]).then(() => {
            console.log('hit');
            this.recalcSumQuantityEntered();

            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    webpage_heading: string;
    consignmentline_keyno: string;
    prod_id: string;
    prod_name: string;
    quantity_total: string;
    sum_quantity_entered: string | number;
    validation_text: string;
    show_validation_text: string;
}

interface SplitLineItem {
    consignmentline_keyno: string;
    quantity_topick: string | number;
    consignmentplan_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentSplitLine', {
//        templateUrl: 'views/components/views/consignmentSplitLine/consignmentSplitLine.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'utilityService', 'consignmentSplitLineService', function ($stateParams, stateService, translateService, modalService, utilityService, consignmentSplitLineService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let consignmentLineKeyno = $stateParams.consignmentline_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                inputListSplitLines: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await consignmentSplitLineService.getEdit({ consignmentline_keyno: consignmentLineKeyno }))[0];
//            }

//            async function loadSplitLines() {
//                if (utilityService.validateParmsValue(vm.model.edit.consignmentline_keyno) !== true) return;

//                return vm.model.inputListSplitLines = await consignmentSplitLineService.listSplitLines({ consignmentline_keyno: vm.model.edit.consignmentline_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region RECALCULATION FUNCTION

//            function recalcSumQuantityEntered() {
//                setTimeout(() => {
//                    vm.model.edit.sum_quantity_entered = 0;

//                    vm.model.inputListSplitLines.forEach((line) => {
//                        let numberQuantityToPick = utilityService.parseNumber(line.quantity_topick);
//                        let numberFixed2Decimals = Math.floor(numberQuantityToPick * 100) / 100;

//                        vm.model.edit.sum_quantity_entered += numberFixed2Decimals;
//                    });

//                    if (utilityService.parseNumber(vm.model.edit.quantity_total) !== utilityService.parseNumber(vm.model.edit.sum_quantity_entered)) {
//                        vm.model.edit.show_validation_text = '1';
//                    } else {
//                        vm.model.edit.show_validation_text = '0';
//                    }
//                }, 500);
//            }

//            // #endregion RECALCULATION FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id, item) {
//                switch (id) {
//                    case 'quantity_topick':
//                        if (utilityService.validateWatchValue(value, item.quantity_topick) !== true) return;

//                        item.quantity_topick = value;

//                        if (utilityService.validateParmsValue(item.quantity_topick, true) !== true) return;

//                        recalcSumQuantityEntered()
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
//                let inputNumbers = [];

//                vm.model.inputListSplitLines.forEach((item) => {
//                    inputNumbers.push({
//                        consignmentline_keyno: item.consignmentline_keyno,
//                        quantity_topick: item.quantity_topick
//                    });
//                });

//                consignmentSplitLineService.saveObj({
//                    quantity_total: vm.model.edit.quantity_total,
//                    consignmentline_keyno: vm.model.edit.consignmentline_keyno,
//                    records: inputNumbers
//                }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadSplitLines();
//                recalcSumQuantityEntered();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
